import { AzureAuthProvider, AzureAuthConfiguration } from "@datamole/wds-azure-auth";
import { type ReactNode } from "react";

import { config } from "@/config";

const azureAuthConfiguration: AzureAuthConfiguration = {
    authorityUrl: config.AZURE_AUTH_AUTHORITY_URL,
    clientId: config.AZURE_AUTH_CLIENT_ID,
    redirectUrl: config.AZURE_AUTH_REDIRECT_URL,
    postLogoutRedirectUrl: config.AZURE_AUTH_POST_LOGOUT_REDIRECT_URL,
};

type Props = {
    children: ReactNode;
};

export const AuthProvider = (props: Props) => {
    const { children } = props;

    return <AzureAuthProvider configuration={azureAuthConfiguration}>{children}</AzureAuthProvider>;
};
